import { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';
import { getCookie } from 'utils/cookie.helper';
import { REGION_ID_COOKIE } from 'pages/common/consts/cookies';

const getCurrentRegionId = (presaleRegionId?: number) => {
  if (presaleRegionId !== undefined) {
    return String(presaleRegionId);
  }

  return getCookie(REGION_ID_COOKIE);
};

export const useRegionMismatch = () => {
  const { data } = useContext(DataContext);

  if (__IS_SERVER__) {
    return {
      isRegionMismatch: true,
    };
  }

  const savedRegionId = data?.regionId?.toString();
  const currentRegionId = getCurrentRegionId(data?.presaleProps?.regionId);
  const isRegionMismatch = !savedRegionId || !currentRegionId || savedRegionId !== currentRegionId;

  return {
    isRegionMismatch,
  };
};
